var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#1A6EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7212 6.96136C16.3499 6.58959 15.747 6.58982 15.3752 6.96136L9.31744 13.0194L6.62503 10.327C6.25325 9.95519 5.65061 9.95519 5.27883 10.327C4.90706 10.6987 4.90706 11.3014 5.27883 11.6732L8.6442 15.0385C8.82998 15.2243 9.07357 15.3174 9.31719 15.3174C9.5608 15.3174 9.80463 15.2245 9.9904 15.0385L16.7212 8.30753C17.0929 7.93602 17.0929 7.33311 16.7212 6.96136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.275dd48030e32ee53b8930228215edf3.svg";
export { ForwardRef as ReactComponent };